import { render } from "./AppHeader.vue?vue&type=template&id=6d9ead94"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aks/Desktop/WORK/Codes/HCL Harit/chatbot-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__